import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { PickupComponent } from '../../pickup.shared.component';

import { Observable } from 'rxjs';
import { take, map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'shared-pickup-for-schedule',
    templateUrl: './pickup-for-schedule.shared.component.html',
    styleUrls: ['./pickup-for-schedule.shared.component.scss']
})
export class PickupForScheduleComponent extends PickupComponent implements OnInit {
    private _form!: FormGroup;
    private _tempSelected!: OLO.Ordering.IPickupTime;

    @Input() public update: boolean = false;
    @Output() public onPickupSelected: EventEmitter<OLO.Ordering.IPickupTime> = new EventEmitter();
    @Output() public onFormInit: EventEmitter<{
        form: FormGroup;
        context: OLO.Common.IFormContext<PickupForScheduleComponent>;
    }> = new EventEmitter();

    ngOnInit(): void {
        this.mode = 'schedule';
        super.ngOnInit();
    }

    public handleFormInit($event: FormGroup): void {
        this._form = $event;
        this.onFormInit.emit({
            form: $event,
            context: this,
        });
    }

    public handlePickupTimeSelected($event: OLO.Ordering.IPickupTime): void {
        this._tempSelected = $event;
        this.onPickupSelected.emit(this._tempSelected);
    }

    public formSubmit(): void {
        super.dropdownSelected(this._tempSelected, this.update);
    }
}
